import React from 'react';
import { IconPrint } from '@americanexpress/dls-react';

function PrintPage() {
    const printModal = (e) => { e.preventDefault(); window.print() }
    return (
        <div className="stack">
            <div className="row">
                <div className="col-md-12 text-align-center pad-1 nav-link">
                    <a className="nav-link" href="/#" onClick={printModal}>
                        <IconPrint
                            size="sm"
                            theme={{
                                color: '#006fcf !important',
                                fill: '#006fcf !important'
                            }}
                        />
                        <span>&nbsp;Print this page</span>
                    </a>
                </div>
            </div>
        </div>
    );
}
export default PrintPage;